<lib-page-container [title]="title" [loading]="screen.isLoading()" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <div lib-page-actions>
    <lib-button (click)="add()" tooltip="Create code" icon="add"> Create codes</lib-button>
    <lib-button (click)="import()" tooltip="Import codes" icon="add"> Import codes</lib-button>
  </div>
  <div lib-page-body>

  </div>
</lib-page-container>